
window.ECV_CONFIGURATION='DEMO';
console.log("ECV CONFIGURATION = DEMO");
let modules = [
import('../modules/CoreModules/Demo'),
import('../modules/CoreModules/PureWebRTC'),
import('../modules/CoreModules/ExternalAdapter'),
import('../modules/CoreModules/Photo'),
import('../modules/CoreModules/Chat'),
import('../modules/CoreModules/ScreenShare'),
import('../modules/CoreModules/BgBlur'),
import('../modules/CoreModules/Announcement'),
import('../modules/CoreModules/MobileWebSwitchCamera'),
import('../modules/CoreModules/RemoteFlashTrigger'),
import('../modules/CoreModules/Whisper'),
import('../modules/CoreModules/Transfer'),
import('../modules/CoreModules/ScreenShooter'),
import('../modules/CoreModules/Snippet'),
import('../modules/CoreModules/MediaSwitcher'),];
export default modules;